import type { TenantConfig } from '@/types/TenantConfig'

const green = '#355327'
const darkGreen = '#303E25'
const navy = '#26303D'
const teal = '#0F9F6C'

export const phillyzoo: TenantConfig = {
  logo: 'assets/phillyzoo/static/logo.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: teal,
    secondaryColor: teal,
    logoHeight: '80px',
    headerHeight: '130px',
    headerBackground: navy,
    cartHeaderBackgroundColor: navy,
    cartHeaderTextColor: 'white',
    footerBackgroundColor: darkGreen,
    footerTextColor: 'white',
    memberLinksColor: 'white',
    memberLinksColorHover: teal,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/phillyzoo/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-180px',
        mobile: '-110px',
      },
    },
  },
}
